import * as React from 'react';

import { Menu } from 'antd';

export default Menu;
